export const Props = () => ({
  //Текущее время
  currentTime: { type: String },

  //Длительность аудио
  durationTime: { type: String }
});